import EventBanner from '../event-stats-banner/EventBanner';

const SchoolEventBannerOD = ({ eventId, schoolOrgNumber }) => {
    return (
        <EventBanner
            eventId={eventId}
            schoolOrgNumber={schoolOrgNumber}
            numberOfProjectsIllustration={'campaign/od/od-logo-black.svg'}
            theme={{ adjust: 'center', style: 'simple', mainColor: 'od2022Beige' }}
            title={'Aktivitet'}
        />
    );
};

export default SchoolEventBannerOD;
